export const home = {
  hero: {
    title: "Quality Lead Lists",
    subtitle: "For Sales Teams",
    description: "Stop wasting time on bad leads. Get phone numbers that answer, companies that exist, data that works.",
    freeOffer: "First 100 Numbers FREE",
    contactButton: "Contact Us",
    callButton: "Call Us",
    pricing: "Then €3 per number • No subscription • No hidden costs"
  },
  whatWeDo: {
    title: "Why NovaVenture Is Better",
    description: "Other lists are full of fax numbers, outdated companies, and numbers that never answer. We only deliver data that works.",
    realPhone: {
      title: "Real Phone Numbers",
      description: "No fax numbers. No outdated contacts. Only numbers answered by real businesses."
    },
    activeCompanies: {
      title: "Active Companies",
      description: "All companies filtered by VAT number. No more bankrupt or non-existent companies in your list."
    },
    readyToUse: {
      title: "Ready to Use",
      description: "Delivered in Excel. Ready to import into your CRM. Start calling today."
    }
  },
  whatYouGet: {
    title: "What You Get Per Lead",
    description: "No vague data. No 'company size' scam. Only concrete information your sales team needs.",
    fields: {
      companyName: {
        title: "Company Name",
        description: "Official company name"
      },
      vatNumber: {
        title: "VAT Number",
        description: "Verification that company exists"
      },
      phoneNumber: {
        title: "Phone Number",
        description: "Quality number that answers"
      },
      fullAddress: {
        title: "Full Address",
        description: "Street, number, city"
      },
      postalCode: {
        title: "Postal Code",
        description: "For geographic targeting"
      },
      website: {
        title: "Website",
        description: "For research before you call"
      },
      reviews: {
        title: "Reviews",
        description: "If available"
      },
      openingHours: {
        title: "Opening Hours",
        description: "Know when to call"
      }
    },
    stats: {
      allBelgium: "All Belgium",
      coverage: "Complete coverage",
      allSectors: "All Sectors",
      filterTarget: "Filter by your target",
      languages: "NL + FR",
      bothLanguages: "Both languages"
    }
  },
  pricing: {
    title: "Transparent Pricing",
    description: "No subscriptions. No hidden costs. Pay only for what you use.",
    oneTimeOffer: "One-Time Offer",
    freeNumbers: "100 Numbers",
    completelyFree: "Completely FREE",
    thenOnly: "Then only",
    perNumber: "per phone number",
    features: {
      noSubscription: "No subscription required",
      noHiddenCosts: "No hidden costs",
      payAsYouGo: "Pay only for what you use",
      excelDelivery: "Delivered directly in Excel"
    },
    ctaButton: "Contact Us For Your Free Numbers"
  },
  finalCta: {
    title: "Ready To Get Started?",
    description: "Contact us to claim your 100 free numbers. No credit card required.",
    emailButton: "Send An Email",
    callButton: "Call Us Directly",
    email: "Email:",
    availability: "Available Monday to Friday • Response within 24 hours"
  },
  dataPrivacy: {
    title: "Transparency About Data Processing",
    description: "NovaVenture Group BV processes only publicly available business data. Companies can object to inclusion in our database via",
    email: "David@novaventure.be",
    learnMore: "Learn more"
  }
};